import * as React from 'react';
import { withRouter } from 'react-router-dom';

import classNames from 'classnames';

import { Link } from '@ui';

import { IAppGenre } from '@interfaces';

import { IGenreListProps } from './types';

import * as s from './GenreList.scss';

export const GenreListView: React.FC<IGenreListProps> = (props: IGenreListProps ) => {
	const {
		className,
		genres,
	} = props;
	const genresLength = genres?.length;

	if (!genresLength) {
		return null;
	}

	return (
		<div className={classNames(className, s.genres)}>
			{
				genres.map((genre: IAppGenre, index: number) => {
					return (
						<Link
							className={s.genre}
							key={genre.id}
							to={`/apps/${genre.id}`}>
							{`${genre.name}${index < (genresLength - 1) ? ', ' : ''}`}
						</Link>
					);
				})
			}
		</div>
	);
};

export const GenreList = withRouter(GenreListView);
